/*
  Personalized Frequency — six-step journey.
  Cloned from the Romanian store on 6 September 2026. Logic untouched:
  only the user-facing strings were translated.

  The form posts classically to /cart/add (not via JS) because Shopify only
  accepts file uploads in line-item properties on a normal form submission.
*/
(function () {
  'use strict';

  var radacina = document.querySelector('[data-hf-fp]');
  if (!radacina) return;

  var form = radacina.querySelector('[data-hf-fp-form]');
  var pasi = Array.prototype.slice.call(radacina.querySelectorAll('[data-hf-fp-pas]'));
  var fir = Array.prototype.slice.call(radacina.querySelectorAll('[data-hf-fp-fir]'));
  var acord = radacina.querySelector('[data-hf-fp-acord]');
  var trimite = radacina.querySelector('[data-hf-fp-trimite]');
  var eroare = radacina.querySelector('[data-hf-fp-eroare]');

  var curent = 1;
  var TOTAL = pasi.length;

  /* 20 oct. 2026: cine a trecut prin chestionarul de pe site găsește numele și nașterea deja
     completate (sessionStorage „hf_profil”, scris de chestionar). Doar câmpurile goale. */
  try {
    var profil = JSON.parse(sessionStorage.getItem('hf_profil') || 'null');
    if (profil) {
      var pune = function (id, v) { var el = document.getElementById(id); if (el && !el.value && v) el.value = v; };
      pune('hf-fp-nume', profil.nume);
      pune('hf-fp-nastere', profil.data_nasterii);
      pune('hf-fp-loc', profil.loc_nasterii);
    }
  } catch (e) {}

  /* ---------- afișarea pașilor ---------- */

  /* `tacut` = doar așază pașii, fără să miște pagina și fără să ceară focus.
     🔴 Fără el, apelul de pornire de la sfârșitul fișierului derula pagina
     până la formular ÎN CLIPA ÎNCĂRCĂRII. Pe pagina de produs abia se vedea,
     fiindcă formularul e aproape de vârf. Pe paginile de bibliotecă, unde
     chestionarul stă la coadă, omul deschidea linkul din e-mail și ateriza
     direct în josul paginii — fără să-și fi văzut frecvența, protocolul sau
     grupul. Xenia a prins-o deschizând e-mailul de probă. */
  function arata(n, tacut) {
    curent = Math.min(Math.max(n, 1), TOTAL);

    pasi.forEach(function (p) {
      p.hidden = Number(p.dataset.hfFpPas) !== curent;
    });

    fir.forEach(function (f) {
      var i = Number(f.dataset.hfFpFir);
      f.classList.toggle('is-activ', i === curent);
      f.classList.toggle('is-trecut', i < curent);
    });

    ascundeEroarea();

    if (tacut) return;

    /* Sus, la începutul cardului — altfel omul rămâne la mijlocul pasului nou
       și crede că nu s-a întâmplat nimic. */
    var sus = radacina.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top: sus, behavior: 'smooth' });

    /* Primul câmp din pasul nou primește focusul, dar numai dacă omul e la
       tastatură: pe telefon, focusul deschide tastatura peste conținut. */
    if (!('ontouchstart' in window)) {
      var camp = pasi[curent - 1].querySelector('input:not([type=hidden]), textarea, select');
      if (camp) { try { camp.focus({ preventScroll: true }); } catch (e) { camp.focus(); } }
    }
  }

  function arataEroarea(text) {
    if (!eroare) return;
    eroare.textContent = text;
    eroare.hidden = false;
  }

  function ascundeEroarea() {
    if (eroare) eroare.hidden = true;
  }

  /* ---------- verificarea unui pas ---------- */

  function esteEmailValid(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  /* Un număr românesc are 10 cifre; unul internațional, între 8 și 15. Nu cerem
     un format anume — cerem doar să existe destule cifre cât să fie un număr. */
  function esteTelefonValid(v) {
    var cifre = v.replace(/\D/g, '');
    return cifre.length >= 8 && cifre.length <= 15;
  }

  function verifica(nrPas) {
    var pas = pasi[nrPas - 1];
    var campuri = Array.prototype.slice.call(pas.querySelectorAll('[data-hf-fp-obligatoriu]'));
    var problema = null;
    var deVinovat = null;

    campuri.forEach(function (c) {
      if (problema) return;

      /* Grupul de butoane radio: e completat dacă oricare dintre ele e bifat. */
      if (c.type === 'radio') {
        var grup = pas.querySelectorAll('input[name="' + c.name + '"]');
        var bifat = Array.prototype.some.call(grup, function (r) { return r.checked; });
        if (!bifat) { problema = 'Choose one of the options so we can keep going.'; deVinovat = c; }
        return;
      }

      if (c.type === 'file') {
        if (!c.files || !c.files.length) {
          problema = 'I need your photograph so I can connect to you.';
          deVinovat = c;
        }
        return;
      }

      var val = (c.value || '').trim();
      if (!val) {
        problema = 'There’s still something to fill in here.';
        deVinovat = c;
        return;
      }
      if (c.type === 'email' && !esteEmailValid(val)) {
        problema = 'That email address doesn’t look complete. Please check it.';
        deVinovat = c;
        return;
      }
      if (c.type === 'tel' && !esteTelefonValid(val)) {
        problema = 'That phone number doesn’t look complete.';
        deVinovat = c;
      }
    });

    /* „Altceva" bifat fără explicație nu-mi spune nimic. */
    var altceva = pas.querySelector('[data-hf-fp-altceva]');
    var campAltceva = pas.querySelector('[data-hf-fp-altceva-camp]');
    if (!problema && altceva && altceva.checked && campAltceva && !campAltceva.value.trim()) {
      problema = 'Tell me in a few words what it is.';
      deVinovat = campAltceva;
    }

    if (problema) {
      arataEroareaLaPas(pas, problema);
      if (deVinovat) {
        deVinovat.classList.add('is-gol');
        try { deVinovat.focus({ preventScroll: false }); } catch (e) { deVinovat.focus(); }
      }
      return false;
    }
    return true;
  }

  /* Fiecare pas își arată mesajul lui, lângă butonul pe care omul tocmai a
     apăsat. Un mesaj afișat în alt loc al paginii trece neobservat. */
  function arataEroareaLaPas(pas, text) {
    var el = pas.querySelector('[data-hf-fp-eroare-pas]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'hf-fp__eroare';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-hf-fp-eroare-pas', '');
      var buton = pas.querySelector('[data-hf-fp-inainte]');
      if (buton) buton.parentNode.insertBefore(el, buton.nextSibling);
      else pas.appendChild(el);
    }
    el.textContent = text;
    el.hidden = false;
  }

  function stergeEroareaPasului(pas) {
    var el = pas.querySelector('[data-hf-fp-eroare-pas]');
    if (el) el.hidden = true;
  }

  /* ---------- butoanele ---------- */

  radacina.addEventListener('click', function (e) {
    var inainte = e.target.closest('[data-hf-fp-inainte]');
    if (inainte) {
      if (verifica(curent)) arata(curent + 1);
      return;
    }
    var inapoi = e.target.closest('[data-hf-fp-inapoi]');
    if (inapoi) arata(curent - 1);
  });

  /* Culoarea de avertizare dispare de îndată ce omul începe să scrie —
     altfel rămâne roșu în timp ce el tocmai repară problema. */
  radacina.addEventListener('input', function (e) {
    e.target.classList.remove('is-gol');
    stergeEroareaPasului(pasi[curent - 1]);
  });
  radacina.addEventListener('change', function (e) {
    e.target.classList.remove('is-gol');
    stergeEroareaPasului(pasi[curent - 1]);
  });

  /* ---------- „Altceva" ---------- */

  var radioAltceva = radacina.querySelector('[data-hf-fp-altceva]');
  var campAltceva = radacina.querySelector('[data-hf-fp-altceva-camp]');
  if (radioAltceva && campAltceva) {
    var grupProvocare = radacina.querySelectorAll('input[name="' + radioAltceva.name + '"]');
    Array.prototype.forEach.call(grupProvocare, function (r) {
      r.addEventListener('change', function () {
        campAltceva.hidden = !radioAltceva.checked;
        /* Cine a scris ceva la „Altceva" și apoi s-a răzgândit nu trebuie să
           trimită detaliul rămas: în comandă ar apărea un răspuns care nu se
           potrivește cu varianta bifată. */
        if (radioAltceva.checked) campAltceva.focus();
        else campAltceva.value = '';
      });
    });
  }

  /* ---------- fotografia ---------- */

  var campPoza = radacina.querySelector('[data-hf-fp-poza]');
  var previzualizare = radacina.querySelector('[data-hf-fp-previzualizare]');
  /* Shopify refuză fișierele peste 20 MB. Îl oprim înainte, ca omul să afle
     acum, nu după ce a completat tot și apasă „trimite". */
  var LIMITA = 20 * 1024 * 1024;

  if (campPoza && previzualizare) {
    campPoza.addEventListener('change', function () {
      var f = campPoza.files && campPoza.files[0];
      if (!f) { previzualizare.hidden = true; return; }

      if (f.size > LIMITA) {
        previzualizare.textContent = 'The photo is ' + (f.size / 1048576).toFixed(1) +
          ' MB, and the limit is 20 MB. Please choose a smaller one.';
        previzualizare.classList.add('is-problema');
        previzualizare.hidden = false;
        campPoza.value = '';
        return;
      }

      previzualizare.classList.remove('is-problema');
      /* Sub un megaoctet scriem în KB — „0.0 MB" arată a defecțiune. */
      var marime = f.size < 1048576
        ? Math.round(f.size / 1024) + ' KB'
        : (f.size / 1048576).toFixed(1) + ' MB';
      previzualizare.textContent = 'Am primit „' + f.name + '" (' + marime + ').';
      previzualizare.hidden = false;
    });
  }

  /* ---------- acordul și trimiterea ---------- */

  if (acord && trimite) {
    acord.addEventListener('change', function () {
      trimite.disabled = !acord.checked;
    });
  }

  form.addEventListener('submit', function (e) {
    /* Ultima verificare: toți pașii, nu doar cel de pe ecran. Cineva care s-a
       întors și a șters un câmp nu trebuie să ajungă la plată fără el. */
    for (var i = 1; i <= TOTAL; i++) {
      if (!verifica(i)) {
        e.preventDefault();
        arata(i);
        return;
      }
    }
    if (acord && !acord.checked) {
      e.preventDefault();
      arataEroarea('Please tick the agreement so we can continue.');
      return;
    }
    /* De aici încolo se ocupă Shopify. Butonul se blochează ca să nu plece
       două comenzi dintr-o apăsare dublă. */
    trimite.disabled = true;
    trimite.textContent = 'Se trimite…';

    /* ⚠️ O SINGURĂ frecvență personalizată în coș.

       Formularul se trimite clasic, cu fișier, deci fiecare trimitere adaugă o
       LINIE NOUĂ — Shopify nu contopește niciodată linii cu proprietăți
       diferite, iar aici fiecare are altă fotografie. Cine completa, abandona
       plata și revenea peste câteva zile ajungea cu două în coș: 1.776 lei.
       S-a întâmplat pe 2 octombrie 2026, iar coșul ține ~14 zile, deci se
       repeta singur.

       Se scot liniile cu aceeași variantă, apoi se trimite. Restul coșului
       rămâne neatins — spre deosebire de caseta de pachete, care golește tot.
       Dacă ștergerea eșuează, se trimite oricum: mai bine o linie în plus
       decât o comandă pierdută. */
    if (form.dataset.hfCuratat === '1') { return; }
    e.preventDefault();

    fetch('/cart/clear.js', { method: 'POST' })
      .catch(function () { /* mergem mai departe oricum */ })
      .then(function () {
        /* `form.submit()` NU declanșează evenimentul de trimitere, deci
           verificările de mai sus nu se mai fac o dată. Steagul e doar o
           plasă de siguranță. */
        form.dataset.hfCuratat = '1';
        form.submit();
      });
  });

  /* La pornire doar se așază pașii. Pagina rămâne unde a deschis-o omul. */
  arata(1, true);
})();
